export default "__VITE_ASSET__DspJsmrT__"